import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-gray-800 text-white py-4 mt-auto">
      <div className="container mx-auto px-4">
        <div className="flex flex-col md:flex-row justify-between items-center">
          <div className="mb-2 md:mb-0">
            &copy; {currentYear} PrecisionVelocity Technologies LLC. All rights reserved.
          </div>
          <div className="flex space-x-4">
            <a href="/privacy.html" target="_blank" rel="noopener noreferrer" className="hover:text-gray-300">Privacy Policy</a>
            <a href="terms.html" target="_blank" rel="noopener noreferrer" className="hover:text-gray-300">Terms of Service</a>
            <a href="https://forms.gle/JJoe8sS6mPFvRdgw9" target="_blank" rel="noopener noreferrer" className="hover:text-gray-300">Feedback / Bugs</a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;